const index = () => import('./index')

export default[
  {
    path: '/payer/assignment_requests',
    name: 'payers.assignment_requests',
    component: index,
    meta: { requiresAuth: true }
  }
]



// WEBPACK FOOTER //
// ./src/features/payer/assignment_requests/routes.js